import { render, staticRenderFns } from "./AreaPlantadaSojaParaguai20242025.vue?vue&type=template&id=c72dab28&scoped=true&lang=pug"
import script from "./AreaPlantadaSojaParaguai20242025.vue?vue&type=script&lang=js"
export * from "./AreaPlantadaSojaParaguai20242025.vue?vue&type=script&lang=js"
import style0 from "./AreaPlantadaSojaParaguai20242025.vue?vue&type=style&index=0&id=c72dab28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c72dab28",
  null
  
)

export default component.exports